import React from "react";
import "./Square.scss";
import Button from "components/CustomButton/CustomButton";
const SquareTakeReservations = props => {
  const { goToNextStep } = props;
  const nextStep = () => {
    goToNextStep({ takeReservations: true });
  };

  const skipStep = () => {
    goToNextStep({ takeReservations: false });
  };
  return (
    <div className="square-modal">
      <div className="square-modal__header">Take reservations from your website?</div>
      <div className="square-modal__body">
        <p>
          We see you have a square online site. We can add a button to your website to allow cutomers to book
          reservations.
        </p>
        <p>
          <strong>IMPORTANT</strong>: At this time, this feature only supports restaurant table reservations.
        </p>
      </div>
      <div className="square-modal__footer--center-column  ">
        <div>
          <Button
            onClick={skipStep}
            bsStyle="info"
            className="square-modal__button square-modal__button--left"
            pullRight
            type="button"
          >
            Skip
          </Button>
          <Button onClick={nextStep} bsStyle="info" className="square-modal__button btn-fill" pullRight type="button">
            Yes
          </Button>
        </div>
        <div className="square-modal__footer-text">(Requires Waitly Professional, free trial available)</div>
      </div>
    </div>
  );
};

export default SquareTakeReservations;
